// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import 'flatpickr';
import 'magnific-popup';

//Load Modules
import './modules/alert';
import './modules/eChartDonut';
import './modules/eChartMixed';
import './modules/eChartHorizontal';
import './modules/formSelect';
import './modules/menu';
import './modules/modal';
import './modules/pageNavigation';
import './modules/twoFactorResendCountdown';
import './modules/video';
